import axios from 'axios'
import Conf from 'ui-config'
const ClusterService = {
  uistate: function () {
    return axios.get(Conf.HOST + Conf.LC_IP + '/lc/state')
  },

  licenseFlag: function (params, ssid) {
    return axios.post(Conf.HOST + Conf.LC_IP + '/lc/mgmt/cluster/license_flag', params, {
      headers: {
        SSID: ssid,
      },
    })
  },
  getClustersList: function (ssid, params) {
    var page = params && params.page ? '?page=' + params.page + '&size=' + params.size : ''
    return axios.get(Conf.HOST_S + Conf.LC_IP + '/lc/mgmt/cluster/list' + page, {
      headers: {
        SSID: ssid,
      },
    }
    )
  },
  getClusterDetail: function (ssid, cluster_id) {
    return axios.get(Conf.HOST_S + Conf.LC_IP + '/lc/mgmt/cluster/' + cluster_id, {
      headers: {
        SSID: ssid,
      },
    })
  },
  getSummaryDetail: async function (params) {
    return await axios.get(Conf.HOST_S + Conf.LC_IP + '/lc/mgmt/cluster/' + params.cluster_id + '/summary_details', {
      headers: {
        SSID: params.ssid,
      },
    })
  },
  connectToCore: function (params, ssid) {
    return axios.post(Conf.HOST_S + Conf.LC_IP + '/lc/mgmt/cluster/connect', params, {
      headers: {
        SSID: ssid,
      },
    })
  },
  clusterSetup: function (params, ssid) {
    return axios.post(Conf.HOST_S + Conf.LC_IP + '/lc/mgmt/cluster/setup', params, {
      headers: {
        SSID: ssid,
      },
    })
  },
  validateLicense: function (cluster_id, params, ssid) {
    return axios.post(Conf.HOST_S + Conf.LC_IP + '/' + cluster_id + '/mgmt/license/fetch', params, {
      headers: {
        SSID: ssid,
      },
    })
  },
  acceptEULA: function (params, ssid) {
    return axios.post(Conf.HOST_S + Conf.LC_IP + '/lc/mgmt/cluster/eula', params, {
      headers: {
        SSID: ssid,
      },
    })
  },
  LC_IP: Conf.LC_IP,

  //Stream Config

  getStreamConfig: function (clusterId, ssid) {
    return axios.get(Conf.HOST_S + Conf.LC_IP + '/' + clusterId + '/mgmt/core/stream-config', {
      headers: {
        SSID: ssid,
      },
    })
  },

  putStreamConfig: function (params, clusterId, ssid) {
    return axios.put(Conf.HOST_S + Conf.LC_IP + '/' + clusterId + '/mgmt/core/stream-config', params, {
      headers: {
        SSID: ssid,
      },
    })
  },

  getScopeStreamConfig: function (clusterId, scopeId, ssid) {
    return axios.get(Conf.HOST_S + Conf.LC_IP + '/' + clusterId + '/mgmt/scope/' + scopeId + '/stream-config', {
      headers: {
        SSID: ssid,
      },
    })
  },

  putScopeStreamConfig: function (params, clusterId, scopeId, ssid) {
    return axios.put(Conf.HOST_S + Conf.LC_IP + '/' + clusterId + '/mgmt/scope/' + scopeId + '/stream-config', params, {
      headers: {
        SSID: ssid,
      },
    })
  },

  //Audit Trail

  clusterAudit: function (params, ssid, clusterId) {
    return axios.get(Conf.HOST_S + Conf.LC_IP + '/' + clusterId + '/mgmt/core/audit-trail?start=' + params.from + '&end=' + params.to + '', {
      headers: {
        SSID: ssid,
      },
      params: params,
    })
  },
  consoleAudit: function (params, ssid) {
    return axios.get(Conf.HOST_S + Conf.LC_IP + '/lc/mgmt/audit-trail/?from=' + params.from + '&to=' + params.to + '&pageno=' + params.pageno + '&pagesize=' + params.pagesize, {
      headers: {
        SSID: ssid,
      },
      // params: params,
    })
  },
}

export default ClusterService
